import { render, staticRenderFns } from "./ResolveLedgerComponent.vue?vue&type=template&id=96187882&scoped=true"
import script from "./ResolveLedgerComponent.vue?vue&type=script&lang=js"
export * from "./ResolveLedgerComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96187882",
  null
  
)

export default component.exports